// noinspection DuplicatedCode

import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {downloadExcel} from "react-export-table-to-excel";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

import {alertService} from '../../../../services/AlertService';

import TableCard from "../../../../components/tablecard/TableCard";
import ModalForm from "../../../../components/modal/form/ModalForm";

import {detailAccountSelector, getDetailAccount, insertDetailAccount, updateDetailAccount} from './detailAccountSlice';


import {Colors} from "../../../../assets/Colors";
import {maxPageGlobal} from "../../../../assets/config";

const DetailAccountPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const detailAccount = useSelector(
        detailAccountSelector
    );


    useEffect(() => {
        dispatch(getDetailAccount({
            start: start,
            count: count,
            search: '',
        }));

    }, []);

    useEffect(() => {

        if ((search !== '') && detailAccount.isGetSuccess && !detailAccount.isGetFetching) {
            let calc = detailAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = detailAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && detailAccount.isGetSuccess && !detailAccount.isGetFetching) {
            let calc = detailAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = detailAccount.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!detailAccount?.isGetFetching && detailAccount.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = detailAccount?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = detailAccount.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getDetailAccount({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (detailAccount.isGetSuccess) {
                alertService.success(detailAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getDetailAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (detailAccount.isUpdateSuccess) {
                alertService.success(detailAccount.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateDetailAccount({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetDetailAccount(params) {
    //   return dispatch(getDetailAccount(params));
    // }

    function handleInsertDetailAccount(param) {
        setInsertFetch(true);

        const params = {
            MainAccountID: param.dropdownMainAccountValue,
            SubAccountID: param.dropdownSubAccountValue,
            SubGroupAccountID: param.dropdownSubGroupAccountValue,
            DetailAccount: param.inputTwoValue,
            DetailAccountID: param.inputOneValue,
            Saldo: param.inputThreeValue.toString() ? param.inputThreeValue.toString() : 0,
        };

        dispatch(insertDetailAccount(params));
    }

    function handleUpdateDetailAccount(param) {
        setUpdateFetch(true);
        const params = {
            MainAccountID: param.dropdownMainAccountValue,
            SubAccountID: param.dropdownSubAccountValue,
            SubGroupAccountID: param.dropdownSubGroupAccountValue,
            DetailAccount: param.inputOneValue,
            DetailAccountID: currentData.DetailAccountID,
            Saldo: param.inputTwoValue.toString() ? param.inputTwoValue.toString() : 0,
            status: param.status,
        };
        dispatch(updateDetailAccount(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getDetailAccount(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getDetailAccount(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (detailAccount.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? detailAccount.count : newCount,
            search: search,
        }
        dispatch(getDetailAccount(params));

        setPage(1);
        setCount((newCount === "-1") ? detailAccount.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    const exportHeaders = ["No. Akun", "Main Account", "Sub Account", "Sub Group Account", "Nama Detail Account", "Saldo Awal", "Status"];

    async function fetchAllData() {
        const user = JSON.parse(localStorage.getItem("user"));
        const formData = new FormData();
        formData.append("start", 0);
        formData.append("count", detailAccount.count || 99999);
        formData.append("search", search);
        const res = await fetch(process.env.REACT_APP_API_URL + "getMasterDetailAccount", {
            method: "POST",
            headers: {Authorization: "Bearer " + user.Token},
            body: formData,
        });
        const json = await res.json();
        return json.data || [];
    }

    function buildRows(data) {
        return data.map(row => [
            row.DetailAccountID,
            row.MainAccount,
            row.SubAccount,
            row.SubGroupAccount,
            row.DetailAccount,
            row.Saldo,
            row.Status === "1" ? "Aktif" : "Tidak Aktif",
        ]);
    }

    async function handleDownloadExcel() {
        const data = await fetchAllData();
        downloadExcel({
            fileName: "Master_Detail_Account",
            sheet: "Detail Account",
            tablePayload: {header: exportHeaders, body: buildRows(data)},
        });
    }

    async function handleDownloadPDF() {
        const data = await fetchAllData();
        const doc = new jsPDF({orientation: "landscape"});
        doc.setFontSize(14);
        doc.text("Master Detail Account", 14, 15);
        autoTable(doc, {
            startY: 22,
            head: [exportHeaders],
            body: buildRows(data),
            styles: {fontSize: 8},
            headStyles: {fillColor: [41, 128, 185]},
        });
        doc.save("Master_Detail_Account.pdf");
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="DetailAccount"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master DetailAccount"
                                tableData={detailAccount.data}
                                AccountID={true}
                                customAction={
                                    <div className="flex flex-row gap-2">
                                        <button
                                            onClick={handleDownloadExcel}
                                            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm"
                                        >
                                            Download Excel
                                        </button>
                                        <button
                                            onClick={handleDownloadPDF}
                                            className="flex flex-row items-center justify-center my-2 sm:my-0 bg-white hover:bg-gray-100 text-gray-800 font-semibold py-2 px-4 border border-gray-400 rounded shadow text-sm"
                                        >
                                            Download PDF
                                        </button>
                                    </div>
                                }


                                colOneTitle="Main Account"
                                colOneData="MainAccount"
                                colTwoTitle="Sub Account"
                                colTwoData="SubAccount"
                                colThreeTitle="Sub Group Account"
                                colThreeData="SubGroupAccount"
                                colFourTitle="Nama Detail Account"
                                colFourData="DetailAccount"
                                status="Status"

                                fetching={detailAccount.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Detail Account"
                        dropdownMainAccount={true}
                        dropdownSubAccount={true}
                        dropdownSubGroupAccount={true}
                        inputOneTitle="ID Detail Account"
                        inputOnePlaceholder=""
                        inputTwoTitle="Nama Detail Account"
                        inputTwoValue=""
                        inputThreeTitle="Saldo Awal"
                        inputThreeValue=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertDetailAccount}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.DetailAccountID}
                        modal={handleModal}
                        modalTitle="Ubah Detail Account"
                        dropdownMainAccount={true}
                        dropdownMainAccountValue={currentData.MainAccountID}
                        dropdownSubAccount={true}
                        dropdownSubAccountValue={currentData.SubAccountID}
                        dropdownSubGroupAccount={true}
                        dropdownSubGroupAccountValue={currentData.SubGroupAccountID}
                        inputOneTitle="Nama Detail Account"
                        inputOneValue={currentData.DetailAccount}
                        inputTwoTitle="Saldo Awal"
                        inputTwoValue={currentData.Saldo}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateDetailAccount}
                    />
                }
            </div>

        )
    }

}


export default DetailAccountPage;